var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('h3',[_vm._t("title")],2),_vm._v(" "),_vm._t("content")],2),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._t("logs")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }